import React from 'react';
import tpl from '../templates/yellow';
import BaseNewCardView from '../../views/BaseNewCardView';

export default class extends BaseNewCardView {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            ui: this.uiStates.INITIAL,
            tab: 'tariffs'
        };
    }

    static displayName = 'YellowCard.Views.Main';
}
